// src/components/Pagination.jsx
import { PAGE_SIZE_OPTIONS } from "../hooks/usePagination";

const selectStyle = {
  background: "#0d1330",
  border: "1px solid #273067",
  borderRadius: 8,
  color: "#e9eefc",
  padding: "6px 10px",
  cursor: "pointer",
};

const btnStyle = (active) => ({
  background: active ? "#273067" : "transparent",
  border: "1px solid #273067",
  borderRadius: 6,
  color: "#e9eefc",
  padding: "5px 10px",
  cursor: "pointer",
  minWidth: 34,
});

export default function Pagination({ page, pageSize, totalPages, totalItems, goTo, changePageSize }) {
  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalItems);

  // Generar páginas visibles (máx 5 botones)
  const pages = [];
  const delta = 2;
  const left = Math.max(1, page - delta);
  const right = Math.min(totalPages, page + delta);
  for (let i = left; i <= right; i++) pages.push(i);

  if (totalItems === 0) return null;

  return (
    <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap", marginTop: 16, paddingTop: 12, borderTop: "1px solid #273067" }}>
      {/* Selector de tamaño */}
      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        <span className="meta">Mostrar:</span>
        <select value={pageSize} onChange={(e) => changePageSize(Number(e.target.value))} style={selectStyle}>
          {PAGE_SIZE_OPTIONS.map(s => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
        <span className="meta">por página</span>
      </div>

      {/* Info */}
      <span className="meta" style={{ flex: 1, textAlign: "center" }}>
        {start}–{end} de {totalItems}
      </span>

      {/* Botones de navegación */}
      <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
        <button style={btnStyle(false)} onClick={() => goTo(1)} disabled={page === 1}>«</button>
        <button style={btnStyle(false)} onClick={() => goTo(page - 1)} disabled={page === 1}>‹</button>
        {left > 1 && <span className="meta" style={{ padding: "0 4px" }}>…</span>}
        {pages.map(p => (
          <button key={p} style={btnStyle(p === page)} onClick={() => goTo(p)}>{p}</button>
        ))}
        {right < totalPages && <span className="meta" style={{ padding: "0 4px" }}>…</span>}
        <button style={btnStyle(false)} onClick={() => goTo(page + 1)} disabled={page === totalPages}>›</button>
        <button style={btnStyle(false)} onClick={() => goTo(totalPages)} disabled={page === totalPages}>»</button>
      </div>
    </div>
  );
}
